import { Vue, Component } from 'vue-property-decorator';
import { PageDTO, PageContainerDTO, PageElementsDTO } from '@/data/dto/page.dto';

@Component
export default class UsefulFilesPageMixin extends Vue {
  get getUsefulFilesPageAll(): PageDTO | null {
    return (this as any).usefulFilesPageStore.all;
  }

  getContainer(index: number): PageContainerDTO | undefined {
    return this.getUsefulFilesPageAll?.data?.containers[index];
  }

  getElement(containerIndex: number, elementIndex: number): PageElementsDTO | undefined {
    return this.getContainer(containerIndex)?.elements[elementIndex];
  }

  getElementTitle(containerIndex: number, elementIndex: number): string {
    return this.getElement(containerIndex, elementIndex)?.title || '';
  }

  getElementText(containerIndex: number, elementIndex: number): string {
    return this.getElement(containerIndex, elementIndex)?.text || '';
  }

  getElementLink(containerIndex: number, elementIndex: number): string | null {
    const link = this.getElement(containerIndex, elementIndex)?.link?.trim();

    return link ? link : null;
  }

  getElementMedia(containerIndex: number, elementIndex: number): string {
    return this.getElement(containerIndex, elementIndex)?.media || '';
  }
}